import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TripService } from '../services/trip.service';

/** Mobile route for travel-quote requests — only while the trip is active. */
export const requestTravelQuoteGuard: CanActivateFn = () => {
  const tripService = inject(TripService);
  const router = inject(Router);

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  if (tripService.hasEnded()) {
    return router.createUrlTree(['/prep-planning']);
  }

  return true;
};
